import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoiComponent } from './poi.component';

@NgModule({
    declarations: [
        PoiComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        PoiComponent
    ]
})
export class NcPoiModule { }